import { track } from '@opallabs/quanta'

export const withOnSelectTracking =
  (fn, { versionId, versionNumber }) =>
  (e) => {
    track('Content: View Longform Version', {
      'Version ID': versionId,
      'Version Number': versionNumber,
    })
    return fn(e)
  }

export const withOnRestoreTracking =
  (fn, { versionNumber }) =>
  (e) => {
    track('Content: Restore Longform Version', {
      'Version Number': versionNumber,
    })
    return fn(e)
  }
